//所有主题 列表页 搜索页 需要获取插件的统一入口;
import { mapActions, mapState } from 'vuex'
const mix = {
  methods: {
    ...mapActions({
      get_custom_button: 'get_custom_button', //获取自定义按钮
      //   get_product_tag: 'change_product_tag_list', // 将 `this.get_product_tag()` 映射为 `this.$store.dispatch('change_product_tag_list')`
      //   get_product_palette: 'get_product_palette', //将 `this.get_product_palette()` 映射为 `this.$store.dispatch('get_product_palette')`
    }),
  },
  computed: {
    ...mapState({
      mix_custom_button_list: (state) => {
        return state.custom_button_list
      },
    }),
  },
  watch: {
    products_ids(newV) {
      // if (this.palette_config) {
      //   this.get_product_palette(this.products_ids)
      // }
      // if (this.product_tag) {
      //   this.get_product_tag(this.products_ids)
      // }
      if (this.is_custom_button) {
        this.get_custom_button(newV.join(','))
      }
    },
  },
}
export default mix
